var render = function render(){var _vm=this,_c=_vm._self._c;return _c('line-chart',{ref:"chart",staticStyle:{"height":"210px"},attrs:{"labels":_vm.labels,"datasets":_vm.datasets,"paddingTop":"24"}})
}
var staticRenderFns = []

export { render, staticRenderFns }